import { createMutationHelper } from '@utils/swr'
import { type FastOrderItemsCheckBody, type FastOrderMallRequest } from '../types/apiRequest'
import { type FastOrderItemsCheckResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['post']['fastOrderItemsCheck'], FastOrderItemsCheckResponse, FastOrderItemsCheckBody, FastOrderMallRequest>({
  client: 'fortune',
  key: params => params?.mall_code ? `/cross-brand-malls/${params.mall_code}/fast-order/items-check` : null,
  fetcher: (url, { arg, client }) => client.post(url, arg),
})

export const useApiFastOrderItemsCheck = useMutation
